import { Navigate, Outlet } from 'react-router-dom';
import { getAuthFlag } from '../utils/authUser';

function PrivateRoutes() {
  const isAuth = getAuthFlag() && localStorage.getItem('userID');

  return isAuth ? <Outlet /> : <Navigate to="/login" replace />;
}

export default PrivateRoutes;